import React from 'react';
import MuiContainer from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  content: {
    paddingTop: '8px',
  },
}));

const BaseContainer = MuiContainer;

BaseContainer.propTypes = {
  component: PropTypes.elementType,
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
};

const Container = (props) => {
  const classes = useStyles();

  return (
    <BaseContainer maxWidth='lg' {...props}>
      <Toolbar />
      <div className={classes.content}>
        {props.children}
      </div>
    </BaseContainer>
  )
};

// const Container = BaseContainer;

export default Container;
